import { dashboardConstants } from '../constants/dashboard';
import { dashboard } from '../services/ApiService';

export const setDashboardCharts = (charts, totalCharts) => ({
  type: dashboardConstants.SET_CHARTS_SUCCESS,
  charts,
  totalCharts,
});

export const startSetDashboardCharts = params => dispatch =>
  dashboard
    .getСharts(params)
    .then((data = {}) => dispatch(setDashboardCharts(data.items, data.total)))
    .catch(err => dispatch({ type: dashboardConstants.SET_CHARTS_FAILURE }));

export const setDashboardSummary = items => ({
  type: dashboardConstants.SET_SUMMARY_SUCCESS,
  leads: items.leads,
  sum: items.sum,
});

export const startSetDashboardSummary = () => dispatch =>
  dashboard
    .getSummary()
    .then((data = {}) => dispatch(setDashboardSummary(data.items)))
    .catch(err => dispatch({ type: dashboardConstants.SET_SUMMARY_FAILURE }));

export const setDashboardReferralsStats = (stats = {}) => ({
  type: dashboardConstants.SET_DASHBOARD_REFERRAL_STATS_SUCCESS,
  stats,
});

export const startSetDashboardReferralsStats = () => dispatch =>
  dashboard
    .getReferralsStats()
    .then(({ count = 0, income = 0 }) => dispatch(setDashboardReferralsStats({ count, income })))
    .catch(err =>
      dispatch({
        type: dashboardConstants.SET_DASHBOARD_REFERRAL_STATS_FAILURE,
      }),
    );
